import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { find, get } from 'lodash';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import messages from 'containers/CourtManagerLegalProceedings/Provision/messages';
import { translate } from 'containers/services/translate';
import FileIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/file-icon';
import AddIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/add-icon';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import ProvisionIntervenantDialog from 'containers/RecapManagerPage/ProvisionIntervenantDialog';
import StakeHolderDialog from 'containers/CourtManagerLegalProceedings/Provision/StakeHolderDialog';
import { Listings } from 'containers/AppContainer/typings';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import AddFeeNoteDialog from 'containers/CourtManagerLegalProceedings/Provision/AddFeeNoteDialog';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import {
  DEFAULT_LINK_BENEFICIARY_CODE,
  DEFAULT_LINK_PROVIDER,
  PROCEDURE_STEPS,
  PROCEDURE_STEPS_VALUES,
  STATUS_PENDING,
} from 'containers/LawyerFeeNote/constants';
import { isAllValuesIsNil } from 'helpers/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { getPaymentInfoFeeNote } from 'containers/LawyerFeeNote/utils';
import {
  DEFAULT_PROVIDER_CODE,
  DEFAULT_INTERVENANT_CODE,
  HOLDER_PV_PROVIDER,
} from 'containers/RecapPage/canstants';
import moment from 'moment';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { getLimitInvoiceManager } from 'services/utils';

export interface IntervenantProvisionProps {
  intl: IntlShape;
  provisions: any;
  requestValidateProvisionIntervenant?: Function;
  riskId?: string;
  claimNumber?: string;
  setCurrentRisk: Function;
  setUpdateCurrentRisk: Function;
  claimId: number;
  isConsultation: Boolean;
  riskName: String;
  listings: Listings;
  requestCreateStakeHolder?: Function;
  lossDate: any;
  uploadedDocument: any;
  resetUploadDocumentStore: Function;
  uploadDocument: Function;
  requestCreateFeeNoteManager: Function;
}

export const IntervenantProvision: React.FC<IntervenantProvisionProps> = ({
  provisions,
  listings,
  ...props
}): JSX.Element => {
  const [
    isProvisionIntervenantDialogOpen,
    setIsProvisionIntervenantDialogOpen,
  ] = useState<boolean>(false);
  const [isStakeHolderDialogOpen, setIsStakeHolderDialogOpen] = useState<
    boolean
  >(false);
  const [isOpenFeeNoteDialog, setIsOpenFeeNoteDialog] = useState<boolean>(
    false,
  );
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [invoiceReceptionDate, setInvoiceReceptionDate] = React.useState(null);
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [providerType, setProviderType] = React.useState(null);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});

  const [completionDate, setCompletionDate] = React.useState(
    (null as unknown) as Date,
  );
  const [receptionDate, setReceptionDate] = React.useState(
    (null as unknown) as Date,
  );
  const [provider, setProvider] = React.useState(null);

  const [currentIntervenant, setCurrentIntervenant] = useState<string>('');

  const handleProvisionChange = (intervenant: any) => () => {
    setCurrentIntervenant({ ...intervenant });
    setIsProvisionIntervenantDialogOpen(true);
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleValidateFeeNote = () => {
    const providerSagisInfo = find(
      get(listings, 'intervenants'),
      (element: { ItemKey: any; ItemDescription: string }) =>
        element.ItemKey === provider,
    );

    props.requestCreateFeeNoteManager(
      {
        receptionDatePv: moment(receptionDate).format('YYYY-MM-DD'),
        completionDatePv: moment(completionDate).format('YYYY-MM-DD'),
        feeNoteToValidate: {
          step: PROCEDURE_STEPS.PV,
          isMissionFeeNote: false,
          codeIntervenant: provider,
          beneficiary: get(
            get(listings, 'intervenants', [])?.find(
              (el: any) => el.ItemKey === provider,
            ),
            'ItemDescription',
          ),
          createdBy: currentUserStorage?.get()?.username,
          invoiceNumber: invoiceNumber,
          invoiceDate: invoiceDate === 'Invalid date' ? null : invoiceDate,
          receptionDate:
            invoiceReceptionDate === 'Invalid date'
              ? null
              : invoiceReceptionDate,
          InvoiceDate: invoiceDate,
          InvoiceReceptionDate: invoiceReceptionDate,
          contractorCode: provider,
          claimExtCode: props.claimNumber,
          contractorTypeCode:
            providerType === HOLDER_PV_PROVIDER
              ? DEFAULT_PROVIDER_CODE
              : DEFAULT_INTERVENANT_CODE,
          beneficiaryReference: `${PROCEDURE_STEPS_VALUES['PV']}`,
          updateDate: new Date(),
          townCode: get(providerSagisInfo, 'townCode', ''),
          address: get(providerSagisInfo, 'address', ''),
          linkToBeneficiaryCode:
            providerType === HOLDER_PV_PROVIDER
              ? DEFAULT_LINK_PROVIDER
              : DEFAULT_LINK_BENEFICIARY_CODE,
          judgementDate: moment(receptionDate).format('YYYY-MM-DD'),
          ...getPaymentInfoFeeNote(listings),
          documentId: 52,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          isStatusManagement: featureService.hasFeature(
            FEATURES.STATUS_MANAGEMENT,
          ),
        },
        step: PROCEDURE_STEPS.PV,
        username: currentUserStorage?.get()?.username,
        isMissionFeeNote: false,
        codeIntervenant: provider,
        beneficiary: get(
          get(listings, 'intervenants').find(
            (el: any) => el.ItemKey === provider,
          ),
          'ItemDescription',
        ),
        claimId: props.claimId,
        claimNumber: props.claimNumber,
        status: STATUS_PENDING,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        invoiceFeeNote:
          featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
          !isAllValuesIsNil({
            invoiceNumber: invoiceNumber,
            invoiceDate: invoiceDate,
            receptionDate: invoiceReceptionDate,
            url: get(invoiceDocument, 'url', null),
          })
            ? {
                ...invoiceDocument,
                codeIntervenant: provider,
                createdBy: currentUserStorage?.get()?.username,
                invoiceNumber: invoiceNumber,
                invoiceDate:
                  invoiceDate === 'Invalid date' ? null : invoiceDate,
                receptionDate:
                  invoiceReceptionDate === 'Invalid date'
                    ? null
                    : invoiceReceptionDate,
              }
            : undefined,
      },
      successCallBack,
    );
  };

  const successCallBack = () => {
    toast.success(translate(messages.successToastAddFeeNote, props));
    setProviderType(null);
    setProvider(null);
    setCompletionDate(null as any);
    setReceptionDate(null as any);
    setOpenInvoiceFeeNoteInfoDialog(false);
  };
  return (
    <>
      <div className="riskBloc">
        <FileIcon />
        <span>{translate(messages.intervenantProvision, props)}</span>
        {!props.isConsultation &&
          featureService.hasFeature(FEATURES.ADD_STAKE_HOLDER) && (
            <div
              data-testid="add-provision"
              className="evalManuel"
              onClick={() => setIsStakeHolderDialogOpen(true)}
            >
              {props.riskName === RISK_NAME.CORPOREAL && (
                <>
                  <AddIcon />
                  <span style={{ marginLeft: '10px' }}>
                    {translate(messages.addStakeHolder, props)}
                  </span>
                </>
              )}
            </div>
          )}

        {!props.isConsultation &&
          userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
          featureService.hasFeature(FEATURES.ADD_FEE_NOTE_OPENING_MANAGER) && (
            <div
              data-testid="add-fee-note"
              className="evalManuel"
              onClick={() => setIsOpenFeeNoteDialog(true)}
            >
              {props.riskName === RISK_NAME.CORPOREAL && (
                <>
                  <AddIcon />
                  <span
                    style={{
                      position: 'relative',
                      top: '-3px',
                      marginLeft: '2px',
                    }}
                  >
                    {translate(messages.addFeeNote, props)}
                  </span>
                </>
              )}
            </div>
          )}
      </div>
      <div>
        <Table>
          <TableHead>
            <TableRow className="row">
              <TableCell align="left" className="headerTitle">
                {translate(messages.intervenantLastName, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.intervenantType, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.intervenantDesignatedField, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.interProvision, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.intervenantRegulation, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.actionHeader, props)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {provisions.map((el: any) => {
              return (
                <TableRow className="row">
                  <TableCell align="left" className="riskInfo">
                    {el.intervenantName}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.intervenantType}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.designatedField}
                  </TableCell>

                  <TableCell align="left" className="riskInfo">
                    {el.provision}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.regulation}
                  </TableCell>
                  {!props.isConsultation && (
                    <TableCell
                      align="left"
                      className="riskInfo"
                      onClick={handleProvisionChange(el)}
                    >
                      <AddIcon />
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <ProvisionIntervenantDialog
        open={isProvisionIntervenantDialogOpen}
        onClose={setIsProvisionIntervenantDialogOpen}
        requestValidateProvisionIntervenant={
          props.requestValidateProvisionIntervenant
        }
        riskId={props.riskId}
        currentIntervenant={currentIntervenant}
        claimNumber={props.claimNumber}
        setUpdateCurrentRisk={props.setUpdateCurrentRisk}
        claimId={props.claimId}
        listings={listings}
      />
      <StakeHolderDialog
        open={isStakeHolderDialogOpen}
        onClose={setIsStakeHolderDialogOpen}
        riskId={props.riskId}
        claimId={props.claimId}
        listings={listings}
        requestCreateStakeHolder={props.requestCreateStakeHolder}
        claimNumber={props.claimNumber}
        setUpdateCurrentRisk={props.setUpdateCurrentRisk}
        provisions={provisions}
      />
      <AddFeeNoteDialog
        open={isOpenFeeNoteDialog}
        onClose={setIsOpenFeeNoteDialog}
        riskId={props.riskId}
        claimId={props.claimId}
        listings={listings}
        claimNumber={(props.claimNumber as unknown) as string}
        lossDate={props.lossDate}
        setUpdateCurrentRisk={props.setUpdateCurrentRisk}
        uploadedDocument={props.uploadedDocument}
        resetUploadDocumentStore={props.resetUploadDocumentStore}
        uploadDocument={props.uploadDocument}
        setProvider={setProvider}
        provider={provider}
        setCompletionDate={setCompletionDate}
        completionDate={completionDate}
        setReceptionDate={setReceptionDate}
        receptionDate={receptionDate}
        setOpenInvoiceFeeNoteInfoDialog={setOpenInvoiceFeeNoteInfoDialog}
        providerType={providerType}
        setProviderType={setProviderType}
      />
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateFeeNote}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          invoiceReceptionDate={invoiceReceptionDate}
          setInvoiceReceptionDate={setInvoiceReceptionDate}
          isManager={true}
          claimReceptionDate={receptionDate}
          fillReceptionDate={true}
          limitInvoiceDate={getLimitInvoiceManager(
            get(listings, 'appConfig', []),
          )}
        />
      )}
    </>
  );
};

export default injectIntl(IntervenantProvision);
